var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBlogs = function SvgBlogs(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_398_7125)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6667 14.5C12.6667 13.9937 13.0771 13.5833 13.5833 13.5833H26.4167C26.9229 13.5833 27.3333 13.9937 27.3333 14.5C27.3333 15.0063 26.9229 15.4167 26.4167 15.4167H13.5833C13.0771 15.4167 12.6667 15.0063 12.6667 14.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6667 18.1667C12.6667 17.6604 13.0771 17.25 13.5833 17.25H26.4167C26.9229 17.25 27.3333 17.6604 27.3333 18.1667C27.3333 18.6729 26.9229 19.0833 26.4167 19.0833H13.5833C13.0771 19.0833 12.6667 18.6729 12.6667 18.1667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6667 21.8333C12.6667 21.3271 13.0771 20.9167 13.5833 20.9167H26.4167C26.9229 20.9167 27.3333 21.3271 27.3333 21.8333C27.3333 22.3396 26.9229 22.75 26.4167 22.75H13.5833C13.0771 22.75 12.6667 22.3396 12.6667 21.8333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 12.6667C9 10.6416 10.6416 9 12.6667 9H27.3333C29.3584 9 31 10.6416 31 12.6667V23.6667C31 25.6917 29.3584 27.3333 27.3333 27.3333H25.5C24.9937 27.3333 24.5833 26.9229 24.5833 26.4167C24.5833 25.9104 24.9937 25.5 25.5 25.5H27.3333C28.3459 25.5 29.1667 24.6792 29.1667 23.6667V12.6667C29.1667 11.6541 28.3459 10.8333 27.3333 10.8333H12.6667C11.6541 10.8333 10.8333 11.6541 10.8333 12.6667V23.6667C10.8333 24.6792 11.6541 25.5 12.6667 25.5H20.4583C20.9646 25.5 21.375 25.9104 21.375 26.4167C21.375 26.9229 20.9646 27.3333 20.4583 27.3333H12.6667C10.6416 27.3333 9 25.6917 9 23.6667V12.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2009 25.844C20.5171 25.4487 21.094 25.3846 21.4893 25.7009L24.5833 28.1761V26.4167C24.5833 25.9104 24.9937 25.5 25.5 25.5C26.0063 25.5 26.4167 25.9104 26.4167 26.4167V30.0833C26.4167 30.4357 26.2147 30.7569 25.8971 30.9095C25.5795 31.0622 25.2025 31.0193 24.9274 30.7991L20.344 27.1325C19.9487 26.8162 19.8846 26.2394 20.2009 25.844Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_398_7125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(9 9)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBlogs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/blogs.722eb3031de390fdfea3911acdd9da6e.svg";